import { z } from "zod";
// This is the data about a user that we will
// sync to our analytics tools
export const UserAnalyticsSchema = z.object({
    hasBookedMeeting: z.boolean(),
    email: z.string(),
    name: z.string().optional()
});
